import type { CrossSellingServiceResponse } from 'cross-selling/types'
import { mergeProductData } from 'cross-selling/utils/mergeProductData'
import { ClientProductCard } from 'product-card/components/client'
import { ProductDataProvider } from 'product-card/context/ProductDataContext'
import { ProductCardIcon } from 'product-card/types'
import type { Product, ProductImageType } from 'product/types'
import type { ProductLocations } from 'product/types/ProductLocations'
import { cx } from 'utils/cx'

import styles from 'cross-selling/components/shared/CrossSelling/CrossSelling.module.scss'

interface CrossSellingProductsProps {
	crossSellingItems: CrossSellingServiceResponse[]
	productsData: Product[] | undefined
	imageSortCriteria: ProductImageType[]
	location: ProductLocations
	productListId: string
	expanded?: boolean
	hasColorPicker?: boolean
	hasProductLabels?: boolean
	hasProductTags?: boolean
	hasSizeSheetButton?: boolean
	productCardClassName?: string
	hasFavoriteButton?: boolean
}

export const CrossSellingProducts = ({
	crossSellingItems,
	productsData,
	imageSortCriteria,
	expanded,
	hasSizeSheetButton,
	location,
	productListId,
	hasColorPicker = true,
	hasProductLabels = true,
	hasProductTags = true,
	productCardClassName,
	hasFavoriteButton,
}: CrossSellingProductsProps) => {
	const productsFromServer =
		productsData && mergeProductData({ crossSellingItems, productsData })

	return (
		<>
			{productsFromServer
				? productsFromServer.map(
						(product) =>
							product.productData && (
								<ProductDataProvider
									key={`${product.productId}-${product.colorId}-${product.lookId}`}
									initialProductData={product.productData}
								>
									<ClientProductCard
										className={cx(
											styles.crossSellingItem,
											expanded && styles.expanded,
											productCardClassName
										)}
										productId={product.productId}
										colorId={product.colorId}
										lookId={product.lookId}
										imageSortCriteria={imageSortCriteria}
										hasSizeSheetButton={hasSizeSheetButton}
										hasProductLabels={hasProductLabels}
										hasProductTags={hasProductTags}
										hasColorPicker={hasColorPicker}
										dataTestId='crossSelling'
										location={location}
										icon={
											hasFavoriteButton
												? ProductCardIcon.Favorite
												: ProductCardIcon.None
										}
										productListId={productListId}
									/>
								</ProductDataProvider>
							)
					)
				: crossSellingItems.map((product) => (
						<ClientProductCard
							key={`${product.productId}-${product.colorId}-${product.lookId}`}
							className={cx(
								styles.crossSellingItem,
								expanded && styles.expanded,
								productCardClassName
							)}
							productId={product.productId}
							colorId={product.colorId}
							lookId={product.lookId}
							imageSortCriteria={imageSortCriteria}
							hasSizeSheetButton={hasSizeSheetButton}
							hasProductTags={hasProductTags}
							hasColorPicker={hasColorPicker}
							dataTestId='crossSelling'
							location={location}
							icon={
								hasFavoriteButton
									? ProductCardIcon.Favorite
									: ProductCardIcon.None
							}
							productListId={productListId}
						/>
					))}
		</>
	)
}
